import React, { Component } from 'react';
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from '@material-ui/core/Tooltip';
import { getNoteColorFromStatusLabel, getNoteIconNameFromStatusLabel, formatNoteStatus } from '../../redux/siteMonitoring/siteMonitoringStatusActions'
import '../../statusIcon.css'
import { getCurrentFunctionName } from '../../performanceModeManager';

class NoteStatusIcon extends Component {
    render() {
        console.perfLog(getCurrentFunctionName());
        let iconElement;

        iconElement = (
            <Icon className={this.props.className + " status-icon-color-" + getNoteColorFromStatusLabel(this.props.state, this.props.lowlight)}>
                {getNoteIconNameFromStatusLabel(this.props.state)}
            </Icon>
        );

        return (
            <Tooltip title={formatNoteStatus(this.props.state)}>
                {iconElement}
            </Tooltip>
        );
    }
}

export default NoteStatusIcon;
